"use client";
//#region packages/@mantine/core/src/components/Divider/Divider.module.css
var Divider_module_default = {
	"root": "m_3eebeb36",
	"label": "m_9e365f20"
};
//#endregion
export { Divider_module_default as default };

//# sourceMappingURL=Divider.module.mjs.map